// @flow
import { combineReducers } from 'redux';

import * as types from '../types/trips';
import * as common from './common';
import type { ERROR_TYPE } from '../types/common';
import type { TRIP_TYPE } from '../types/trips';

export type TripsState = {
  byId: {[number]: TRIP_TYPE},
  fetching: Array<number>,
  order: Array<number>,
  isFetching: boolean,
  isFInishingTrip: boolean,
  error: ERROR_TYPE
};

const byId = common.byId({
  fetched: [types.TRIPS_FETCH_SUCCEED, types.TRIPS_SCHOOL_FETCH_SUCCESS],
  added: [types.TRIP_ADDED],
  removed: [types.TRIP_REMOVED],
  updated: [
    types.TRIP_UPDATED,
    types.TRIP_OPENED,
    types.TRIP_CLOSED,
    types.TRIP_COMPLETED,
    types.TRIP_DETAIL_SHOWN,
    types.TRIP_DETAIL_HIDDEN,
  ],
  defaultAttributes: {
    isOpen: false,
    isShowingDetail: false,
  },
});


const fetching = common.fetching({
  started: [types.TRIP_FETCH_STARTED],
  succeed: [types.TRIP_FETCH_SUCCEED],
  failed: [types.TRIP_FETCH_FAILED],
});

const order = common.order({
  added: [
    types.TRIP_FETCH_SUCCEED,
    types.TRIPS_SCHOOL_FETCH_SUCCESS,
    types.TRIPS_FETCH_SUCCEED,
  ],
  fetched: [
    types.TRIPS_SCHOOL_FETCH_SUCCESS,
    types.TRIPS_FETCH_SUCCEED,
  ],
  removed: [types.TRIP_REMOVED],
});

const isFetching = common.isFetching({
  started: [
    types.TRIPS_FETCH_STARTED,
    types.TRIP_CREATION_STARTED,
  ],
  succeed: [types.TRIPS_FETCH_SUCCEED],
  failed: [types.TRIPS_FETCH_FAILED],
});

const isFinishingTrip = common.isFetching({
  started: [types.FINISH_TRIP_STARTED],
  succeed: [types.FINISH_TRIP_SUCCEED],
  failed: [types.FINISH_TRIP_FAILED],
});

const error = common.error({
  populate: [
    types.TRIPS_FETCH_FAILED,
    types.TRIP_CREATION_FAILED,
    types.TAKE_TRIP_ASSISTANCE_FAILED,
    types.FINISH_TRIP_FAILED,
  ],
  clear: [
    types.TRIPS_FETCH_STARTED,
    types.TRIP_CREATION_STARTED,
    types.TAKE_TRIP_ASSISTANCE_STARTED,
    types.FINISH_TRIP_SUCCEED,
  ],
});

const trips = combineReducers({
  byId,
  fetching,
  order,
  isFetching,
  isFinishingTrip,
  error,
});

export default trips;

export const getTrip = (state: TripsState, id: number): TRIP_TYPE => state.byId[id];
export const getTrips = (
  state: TripsState,
): Array<TRIP_TYPE> => state.order.map(id => getTrip(state, id));

// TODO: Add logic to support when we are viewing a specific route.
export const getVisibleTrips = (
  state: TripsState,
): Array<TRIP_TYPE> => {
  const list = state.order.map(elm => state.byId[elm]);
  return list.filter(elm => elm != null);
}
export const isTripFetching = (state: TripsState, id: number) => state.fetching.includes(id);
export const isFetchingTrips = (state: TripsState) => state.isFetching;
export const getIsFinishingTrip = (state: TripsState) => state.isFinishingTrip;
export const isTripOpen = (state: TripsState, id: number) => state.byId[id].isOpen;
export const isTripShowingDetail = (
  state: TripsState,
  id: number,
) => state.byId[id].isShowingDetail;
export const isTripCompleted = (state: TripsState, id: number) => state.byId[id].is_completed;
export const getRouteId = (state: TripsState, id: number) => state.byId[id].route;
export const getTripStopsIds = (state: TripsState, id: number) => state.byId[id].stops;
export const getTripBusId = (state: TripsState, id: number) => state.byId[id].bus;
export const getTripsError = (state: TripsState) => state.error;



// WEBPACK FOOTER //
// ./src/scripts/reducers/trips.js